import React, { useState } from 'react';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';
import TextField from '@material-ui/core/TextField'

const SettingTextInput = ({ value, label, onChange }) => {
    const [state, setState] = useState(value);

    const handleStateChange = text => {
        setState(text);
        onChange(text);
    };

    return <TextField
        label={label}
        value={state}
        onChange={({ target: { value } }) => handleStateChange(value)}
        style={{ minWidth: '500px' }}
    />
}

const SettingIntegerInput = ({ value, label, onChange }) => {
    const [state, setState] = useState(value);

    const handleStateChange = text => {
        setState(text);
        onChange(text);
    };

    return <TextField
        type="number"
        label={label}
        value={state}
        onChange={({ target: { value } }) => handleStateChange(value)}
        style={{ minWidth: '500px' }}
    />
}


const SettingEditor = ({ setting, onChange }) => {
    const { attributes: { value, description, type } } = setting;

    const handleChange = value => {
        onChange && onChange({ ...setting, attributes: { ...setting.attributes, value } })
    }

    return (
        <div>
            {
                type === 'boolean' &&
                <MuiSwitch value={value} label={description} onChange={handleChange} />
            }
            {
                ['email', 'string'].includes(type) &&
                <SettingTextInput value={value} label={description} onChange={handleChange} />
            }
            {
                type === 'integer' && 
                <SettingIntegerInput value={value} label={description} onChange={handleChange} />
            }
        </div>
    );
};

export default SettingEditor;